import { Skeleton } from 'antd';

export const NewsSkeleton = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="bg-white rounded-2xl shadow-sm overflow-hidden">
        {/* En-tête Skeleton */}
        <div className="px-4 sm:px-6 lg:px-8 pt-12 pb-16 border-b border-neutral-200 bg-gradient-to-br from-primary/5 via-primary/10 to-primary/5">
          <div className="max-w-4xl mx-auto text-center">
            <div className="inline-block w-48 h-8 bg-primary-50 rounded-full mb-6 mx-auto"></div>
            <Skeleton.Input active size="large" className="!w-[70%] !h-[60px] !mb-8 mx-auto" />
            <div className="max-w-3xl mx-auto">
              <Skeleton active paragraph={{ rows: 2 }} />
            </div>
          </div>
        </div>

        {/* Section des articles */}
        <div className="px-4 sm:px-6 lg:px-8 py-12">
          <Skeleton.Input active size="large" className="!w-[240px] !h-[32px] !mb-8" />
          
          {/* Article principal */}
          <div className="mb-16">
            <div className="grid lg:grid-cols-2 gap-8 bg-gradient-to-b from-neutral-50 to-white rounded-2xl overflow-hidden shadow-sm border border-neutral-100">
              <div className="aspect-[16/9] lg:aspect-[4/3] overflow-hidden bg-neutral-100">
                <Skeleton.Image active className="!w-full !h-full" />
              </div>
              <div className="flex flex-col justify-center p-8">
                <div className="inline-block w-32 h-6 bg-primary-50 rounded-full mb-4"></div>
                <Skeleton.Input active size="large" className="!w-[80%] !h-[40px] !mb-4" />
                <Skeleton active paragraph={{ rows: 3 }} className="mb-6" />
                <div className="inline-block w-48 h-8 bg-neutral-100 rounded-lg"></div>
              </div>
            </div>
          </div>

          {/* Grille d'articles */}
          <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
            {[...Array(6)].map((_, index) => (
              <div key={index} className="group flex flex-col bg-white rounded-2xl overflow-hidden shadow-sm border border-neutral-100">
                <div className="aspect-[16/9] overflow-hidden bg-neutral-100">
                  <Skeleton.Image active className="!w-full !h-full" />
                </div>
                <div className="flex flex-col flex-1 p-6">
                  <div className="mb-4">
                    <Skeleton.Input active size="small" className="!w-[120px]" />
                  </div>
                  <Skeleton.Input active size="large" className="!w-[90%] !mb-3" />
                  <Skeleton active paragraph={{ rows: 2 }} className="mb-4" />
                  <div className="inline-block w-32 h-6 bg-neutral-100 rounded-lg mt-auto"></div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Section des fonctionnalités */}
        <div className="px-4 sm:px-6 lg:px-8 py-12 bg-gradient-to-br from-neutral-50 to-white border-t border-neutral-200">
          <Skeleton.Input active size="large" className="!w-[300px] !h-[32px] !mb-8" />
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {[...Array(4)].map((_, index) => (
              <div key={index} className="bg-white/90 p-6 rounded-lg shadow-sm border border-neutral-100">
                <div className="flex items-center gap-3 mb-3">
                  <Skeleton.Avatar active size="default" shape="circle" />
                  <Skeleton.Input active size="small" className="!w-[60%]" />
                </div>
                <Skeleton active paragraph={{ rows: 2 }} />
              </div>
            ))}
          </div>
        </div>

        {/* Section FAQ */}
        <div className="px-4 sm:px-6 lg:px-8 py-8 bg-gradient-to-br from-neutral-50 to-white border-t border-neutral-200">
          <Skeleton.Input active size="large" className="!w-[260px] !h-[32px] !mb-6" />
          <div className="grid md:grid-cols-2 gap-6 mb-8">
            {[...Array(2)].map((_, index) => (
              <div key={index} className="bg-white p-6 rounded-lg shadow-sm border border-neutral-100">
                <Skeleton.Input active size="small" className="!w-[80%] !mb-2" />
                <Skeleton active paragraph={{ rows: 2 }} />
              </div>
            ))}
          </div>
        </div>

        {/* Pagination Skeleton */}
        <div className="px-4 sm:px-6 lg:px-8 py-8 border-t border-neutral-200 bg-gradient-to-br from-primary/5 to-primary/10">
          <div className="flex justify-center items-center gap-3">
            <Skeleton.Button active size="small" className="!w-[40px] !h-[40px]" />
            {[...Array(3)].map((_, index) => (
              <Skeleton.Button key={index} active size="small" className="!w-[40px] !h-[40px]" />
            ))}
            <Skeleton.Button active size="small" className="!w-[40px] !h-[40px]" />
          </div>
        </div>
      </div>
    </div>
  );
}; 